import { createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { useSingle } from '../../state'
import { ActionButton } from './ActionButton'
import { ScoreDialog } from './ScoreDialog'

const StarIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.6l1-5.8L3.5 9.7l5.9-.9z" />
  </svg>
)

export const Score = (props: { size?: 'main' | 'mobile' }) => {
  const { isArchived, takenQuery, setIsScoreOpen } = useService(useSingle)()

  return (
    <ActionButton
      heading={takenQuery.data?.score ? 'Scored' : 'Score'}
      tooltip="Score this setup"
      active={!!takenQuery.data?.score}
      disabled={isArchived()}
      onClick={() => setIsScoreOpen(true)}
      icon={<StarIcon />}
      size={props.size}
    />
  )
}

// Rendered once per page: the Score button appears in every layout, and they all share isScoreOpen
export const CommunityScoreDialog = () => {
  const { setScore: saveScore, takenQuery, upsertTakenMutation, isScoreOpen, setIsScoreOpen } = useService(useSingle)()

  createEffect(() => {
    if (upsertTakenMutation.isSuccess) {
      setIsScoreOpen(false)
      upsertTakenMutation.reset()
    }
  })

  return (
    <ScoreDialog
      title="Community Score"
      isOpen={isScoreOpen()}
      setIsOpen={setIsScoreOpen}
      initialScore={takenQuery.data?.score}
      loading={upsertTakenMutation.isPending}
      onConfirm={saveScore}
    />
  )
}
